<div>
  <ng-content></ng-content>
</div>
<div class="buttons" [fxLayout]="'column'" [fxLayoutAlign]="'start stretch'">
  <vpfa-mobile-action-button (click)="onResetClick()">{{ 'filters.reset' | translate }}</vpfa-mobile-action-button>
  <button nzType="link" nz-button (click)="onApplyClick()">
    {{ 'filters.apply' | translate }}
  </button>
</div>
